module.exports = __webpack_public_path__ + "assets/img/1-4.5b34dd54.png";